<template>
    <div class="bannerdesc">
        <div class="bannerDescRow"  v-for="(item, index) in data" :key="index+91">
            <div class="tit">{{item.title}}：</div>
            <div class="infoList" :class="{open: index == 1 && bannerDeSt, firstNode: index == 0,transNode: index == 1}">
                <div v-for="(it, ind) in item.content" :key="ind+index+10">{{it}}</div>
                <div class="colAll" v-show="bannerDeSt && index == 1" @click="() => {bannerDeSt = false}">收起</div>
            </div>
        </div>
        <div class="openAll" @click="() => {bannerDeSt = true}" v-show="!bannerDeSt && data && data[1].content.length > 3">展开</div>
    </div> 
</template>
<script>
export default{
 props:{
     data: null
 },
 data(){
     return {
         bannerDeSt: false
     }
 },
 methods: {

 }
}
</script>
<style lang="scss" scoped>
.bannerdesc{
.bannerDescRow{
    position: relative;
    display: flex;
    .tit{
        color: #19232B;
        font-weight: bold !important;
        min-width: 70px;
    }
    .infoList{
        color: #19232B;
        // padding-right: 50px;
        max-height: 100px;
        padding-right: 20px;
        overflow: hidden;
        transition: 300ms;
        .colAll{
            position: absolute;
            cursor: pointer;
            right: 20px;
            color: #1286FF;
        }
    }
    .firstNode{
        position: relative;
        line-height: 28px;
        top: 2px;
        margin-bottom: 10px;
    }
    .transNode{
        position: absolute;
        width: calc(100% - 90px);
        left: 55px;
        padding-left: 10px;
    }
    .open{
        position: absolute;
        background: rgba(255,255,255,0.95);
        box-shadow: 0px 1px 6px 1px rgba(217,217,217,0.50); 
        border-radius: 5px;
        height: auto;
        max-height: initial !important;
        overflow: inherit;
        z-index: 10;
        padding-bottom: 40px;
    }
}
.openAll{
    position: absolute;
    cursor: pointer;
    bottom:-33px;
    right: 40px;
    color: #1286FF;
}
}
</style>
